import { Routes, Route } from 'react-router-dom';

import TransactionsList from "../pages/TransactionsList";
import NotFound from "../pages/NotFound";
import Layout from "../components/common/Layout";
import SignIn from "../pages/SignIn";
import PrivateRoute from "./PrivateRoute";
import SignUp from "../pages/SignUp";
import Settings from '../pages/Settings';
import WalletRoute from './WalletRoute';
import ChatRoute from './ChatRoute';
import ForgotPassword from '../pages/ForgotPassword';
import ForgotSend from '../pages/ForgotSend';
import ForgotNew from '../pages/ForgotNew';
import { ClientInfoRoute } from './ClientInfoRoute';
import NewExchange from '../pages/NewExchange';

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={
          <PrivateRoute>
            <WalletRoute>
                <NewExchange />
            </WalletRoute>
          </PrivateRoute>} 
        />
        <Route path="settings" element={<PrivateRoute><WalletRoute><Settings /></WalletRoute></PrivateRoute>} />
        <Route path="sign-in" element={<PrivateRoute><SignIn /></PrivateRoute>} />
        <Route path="sign-up" element={<PrivateRoute><SignUp /></PrivateRoute>} />
        <Route path="forgot-password/" element={<PrivateRoute><ForgotPassword /></PrivateRoute>} />
        <Route path="forgot-password/:tk" element={<PrivateRoute><ForgotNew /></PrivateRoute>} />
        <Route path="forgot-send" element={<PrivateRoute><ForgotSend /></PrivateRoute>} />
        <Route path="transactions-list" element={<PrivateRoute><WalletRoute><TransactionsList /></WalletRoute></PrivateRoute>} />
        <Route path="client/:client_id" element={<PrivateRoute><ClientInfoRoute /></PrivateRoute>} />
        <Route path="chat/:chat_id" element={
          <PrivateRoute>
            <WalletRoute>
              <ChatRoute/>
            </WalletRoute>
          </PrivateRoute>} 
        />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;